import axios from "./axios";

export const login = (data) => {
    return axios.post(`/login`, data);
}

export const logout = () => {
    return axios.post(`/logout`);
}

//users
export const getUserList = (params) => {
    return axios.get('/users', {params});
}
export const addUser = (data) => {
    return axios.post(`/user/add`, data);
}
export const updateUser = (data) => {
    return axios.post(`/user/update`, data);
}
export const updateUserStatus = (data) => {
    return axios.post(`/user/update-status`, data);
}


export const getLocationList = (params) => {
    return axios.get('/locations', {params});
}



export const getApplicationList = (data) => {
    return axios.post('/applicationlist', data);
}

export const getDownloadConsentForms = (params) => {
   
    return axios.get('/downloadforms', {params});
}

export const getDownloadphysicianForms = (params) => {
    return axios.get('/application/download-physician-form', {params});
}

export const getStudentList = (params) => {
    return axios.get('/students', {params});
}
export const addStudent = (data) => {
    return axios.post(`/student/add`, data);
}
export const updateStudent = (data) => {
    return axios.post(`/student/update`, data);
}
export const updateStudentStatus = (data) => {
    return axios.post(`/student/update-status`, data);
}
export const addSingleStudent = (data) => {
    return axios.post(`/student/singleadd`, data);
}


export const stafflogin = (data) => {
    return axios.post(`/staff-login`, data);
}


export const getActiveUserList = (params) => {
    return axios.get('/allusers', {params});
}
export const downloadApplicationReport = (data) => {
    return axios.get(`/application-report`, {data});
}

